import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Button, Heading, Tray } from '@frontend/design-system';
import { CALENDAR_TRACKING_IDS } from '../../../trackingIds/calendar-tracking-ids';
import { FilterCount } from '../popover-filter-panel-content/filter-count';

const trackingIds = CALENDAR_TRACKING_IDS.headerBarFilter;

export const CustomTrayHeader = ({ filterCount, onClose }: { onClose: () => void; filterCount?: number }) => {
  const { t } = useTranslation('scheduleCalendarFilters');
  return (
    <Tray.Header
      Buttons={
        <Button
          variant='secondary'
          onClick={onClose}
          iconName='x'
          label={t('Close')}
          trackingId={trackingIds.closeFilterButton}
        />
      }
      css={{ padding: theme.spacing(2) }}
    >
      <Heading level={2} css={{ display: 'flex', alignItems: 'center', gap: theme.spacing(1) }}>
        <Icon name='filter-alt' />
        {t('Filters')}
        <FilterCount count={filterCount} size='large' />
      </Heading>
    </Tray.Header>
  );
};
